import React from 'react';
import { Button } from 'antd';

import { Carousel } from 'antd';
import Typical from "react-typical";
const TRANSITION_TIME_OPACITY_S = 1;
const TRANSITION_TIME_ROTATE_S = 2;

const items = [
  {
    key: '1',
    title: 'Power your apps with Chaperone API',
    content: 'Learn the basics of Chaperone API, view available resources and join a community of developers building with the Chaperone API.',
  }
]

function AppHero() {
  return (
    <div id="hero" className="heroBlock">
      <Carousel>
        {items.map(item => {
          return (
            <div key={item.key} className="container-fluid">
              <div className="content">
              <Typical
                className="typical"
                steps={[
                  "Welcome to",
                  "Chaperone API hub",
                  1000,
                  item.title,
                  500
                ]}
                loop={Infinity}
                wrapper="p"
              />
              
                <p style={{color:'white'}}>{item.content}</p>
                <div className="btnHolder">
                  <Button style={{backgroundColor:'white',color:'#00b33c',borderRadius:10}} size="large"><a href='./SignUp'>Get started with our API</a></Button>
                </div>
              </div>
            </div>  
          );
        })}
      </Carousel>
    </div>
  );
}

export default AppHero;